import { Theme } from '@mui/material/styles';

import { makeStyles } from 'tss-react/mui';

export const useStyles = makeStyles<Theme>()((theme) => ({
  overviewWrapper: {
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(1),
    paddingTop: theme.spacing(1),
  },
  periodSelector: {
    width: '100%',
    marginTop: theme.spacing(2),
  },
  chartsWrapper: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    gap: theme.spacing(3),
  },
  chartSection: {
    display: 'flex',
    flexDirection: 'column',
  },
  chartContainer: {
    ...theme.mixins.appContainer,
    width: '100%',
    padding: 0,
    [theme.breakpoints.down('md')]: {
      padding: 0,
    },
  },
  emptyState: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    minHeight: 400,
  },
}));
